import { HEADLINER_USER_SERVICE_V1_URL } from 'utils/constants';

export const GET_EXPERIMENTS_URL_PATTERN = `${HEADLINER_USER_SERVICE_V1_URL}/experiments/variants/me`;
